<div class="card">
  <div class="row p-2" id="search-bar">
    <div class="col-md-2">
      <ng-select
        [items]="clusters"
        [multiple]="false"
        [closeOnSelect]="true"
        bindLabel="name"
        bindValue="uid"
        placeholder="Clusters"
        [(ngModel)]="filters.cluster"
        (change)="changeSearch()"
      />
    </div>
    <div class="col-md-2">
      <ng-select
        [items]="siteStatuses"
        [multiple]="false"
        [closeOnSelect]="true"
        bindLabel="label"
        bindValue="code"
        placeholder="{{ 'Statut' | translate }}"
        [(ngModel)]="filters.status"
        (change)="changeSearch()"
      />
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <input
          #searchInput
          id="search"
          type="text"
          placeholder="{{ 'Organization' | translate }} - {{ 'Site' | translate }} - IP"
          class="form-control form-control-sm"
          [(ngModel)]="filters.filter"
          (change)="changeSearch()"
          (keyup)="changeSearch()"
        />
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <ng-select
          [items]="hostModeService.modes"
          [multiple]="false"
          [closeOnSelect]="true"
          bindLabel="label"
          bindValue="value"
          placeholder="{{ 'Mode' | translate }}"
          [(ngModel)]="filters.mode"
          (change)="changeSearch()"
        />
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-check">
        <input
          type="checkbox"
          id="contractIsNull"
          [(ngModel)]="filters.contractIsNull"
          (change)="changeSearch()"
          class="form-check-input"
        />
        <label for="contractIsNull" class="form-check-label">{{ 'Without contract' | translate }}</label>
      </div>
    </div>
    <div class="col-md-2">
      <div class="form-group">
        <button
          [disabled]="!filters.cluster"
          [ngbTooltip]="!filters.cluster && 'Site.ProvByCLuster.DisabledTooltip' | translate"
          (click)="confirmProvCluster()"
          class="ml-2 btn btn-sm btn-danger pull-right"
        >
          PROV CLUSTER
        </button>
        <button (click)="confirmCron12H()" class="btn btn-sm btn-primary pull-right">CRON 12H</button>
      </div>
    </div>
  </div>
  <ngx-datatable
    [messages]="{ emptyMessage: translate.instant('NoData') }"
    #myTable
    class="data-table table-responsive task-list-table"
    [rows]="sites"
    [columnMode]="'flex'"
    [headerHeight]="50"
    [footerHeight]="50"
    [rowHeight]="45"
  >
    <ngx-datatable-column [flexGrow]="2" name="Statut">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Statut' | translate }}
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template>
        <app-site-status [status]="row.status" />
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="3" name="Owner">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Organization' | translate }}
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template>
        <div *ngIf="!row.editOwner">
          <a [routerLink]="['..', 'organizations', row.owner.code]">{{ row.owner.name }}</a
          >&nbsp;
          <app-badge-organization [code]="row.owner.code"></app-badge-organization>
          <i
            (click)="row.editOwner = !row.editOwner"
            class="pointer icofont icofont-edit-alt"
            style="color: #4099ff; font-size: 20px; margin-left: 10px"
            title="{{ 'Edit' | translate }}"
          ></i>
        </div>
        <div *ngIf="row.editOwner" class="flex-align-items">
          <ng-select
            class="user-select"
            notFoundText="{{ 'Min3Chars' | translate }}"
            appendTo="body"
            (search)="loadOrganizations($event.term)"
            [items]="organizations"
            [clearable]="false"
            [multiple]="false"
            [closeOnSelect]="true"
            bindLabel="nameAndCode"
            bindValue="code"
            [(ngModel)]="row.organizationCode"
          >
          </ng-select>
          <i
            (click)="row.editOwner = !row.editOwner; updateOrganizationOwner(row.domainName, row.organizationCode)"
            class="pointer icofont icofont-check"
            style="font-size: 25px; color: rgb(64, 153, 255)"
            title="{{ 'Validate' | translate }}"
          ></i>
          <i
            (click)="row.editOwner = !row.editOwner"
            class="pointer icofont icofont-close"
            style="color: rgb(231, 76, 60); font-size: 20px"
            title="{{ 'Cancel' | translate }}"
          ></i>
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="3" name="Site">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Site' | translate }}
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template>
        <a target="_blank" href="{{ 'http://' + row.domainName }}">{{ row.domainName }}</a>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="2" name="Contract">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Contract.column' | translate }}
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template>
        @if (row.contract) {
          <a [routerLink]="['..', 'contracts', row.contract?.number]">{{ row.contract?.name }}</a
          >&nbsp;
          <app-badge-organization [code]="row.contract?.number"></app-badge-organization>
        }
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="2" name="IP Site" *ngIf="false">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'IpSite' | translate }}
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template>
        <a>{{ row.originServer }}</a>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="2" name="cluster">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Cluster' | translate }}
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template>
        <a>{{ row.cluster.name }}</a>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="2" name="creation" cellClass="date" [minWidth]="100" [maxWidth]="100">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Creation' | translate }}
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template>
        <app-timestamp-cell [value]="row.createdAt" />
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="2" name="Mode" [minWidth]="130" [maxWidth]="130">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Mode' | translate }}
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template>
        <div class="form-group">
          <select
            id="{{ row.domainName + '-mode' }}"
            [ngModel]="row.mode"
            (change)="setMode(row, $event)"
            class="form-control"
            style="position: relative; top: 8px"
          >
            <option *ngFor="let m of hostModeService.modes" [value]="m.value">{{ m.label | translate }}</option>
          </select>
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="2" name="Managed" [minWidth]="90" [maxWidth]="90">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Site.managed.label' | translate }}
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template>
        <div class="form-group">
          <input
            [(ngModel)]="row.managed"
            [checked]="row.managed"
            (change)="updateManaged(row)"
            type="checkbox"
            style="width: 20px; height: 20px; position: relative; top: 10px"
          />
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [flexGrow]="2" name="action" [minWidth]="80" [maxWidth]="80">
      <ng-template let-column="column" ngx-datatable-header-template>
        {{ 'Actions' | translate }}
      </ng-template>
      <ng-template let-row="row" ngx-datatable-cell-template>
        <div
          (click)="refreshStatus(row)"
          class="label label-primary label-sm icon icon-reload"
          title="{{ 'Refresh' | translate }}"
        ></div>
        <div
          (click)="forceProvSite(row)"
          class="label label-danger label-sm icon icon-export"
          title="{{ 'Provision' | translate }}"
        ></div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-footer>
      <ng-template ngx-datatable-footer-template>
        <div>
          Total : <span class="total">{{ totalElements }}</span>
        </div>
        <datatable-pager
          [pagerLeftArrowIcon]="pager.PREV"
          [pagerRightArrowIcon]="pager.NEXT"
          [pagerPreviousIcon]="pager.FIRST"
          [pagerNextIcon]="pager.LAST"
          [page]="curPage"
          [size]="pageSize"
          [count]="totalElements"
          (change)="changePage($event)"
        />
      </ng-template>
    </ngx-datatable-footer>
  </ngx-datatable>
</div>
